import React from 'react';

const Footer:React.FunctionComponent = () => {
  return (
    <></>
  );
}

export { Footer as AdminFooter}